import { Injectable } from '@angular/core';
import { buyerInfoFormFileds } from './custom-payment-buyer-ifno-setting.component';



@Injectable({
  providedIn: 'root'
})
export class CustomPaymentBuyerInfoDataTransform {
    prepareOutPutData(formReult:buyerInfoFormFileds[]){
      return formReult.map(res=> {
        delete res.id;
        if(!res.value[0]?.name){
           res={...res,value:[]}
        }
        return Object.values(res);
      });
    }

    transformIncomingValues(IncomingBuyerInfo:string){
      const ParsedIncoming=JSON.parse(IncomingBuyerInfo);
      if(ParsedIncoming[0].fieldName && ParsedIncoming[0].fieldType) return ParsedIncoming;
     const BuyerInfoFelds:buyerInfoFormFileds[]=ParsedIncoming.map(res=>{
        return {
          id:'',
          fieldName:res[0],
          fieldRequired:res[3],
          fieldType:res[1],
          value:res[2],
        }
      });
      return BuyerInfoFelds;
    }


}
